module.exports = __webpack_public_path__ + "static/media/menu-album.20249d29.png";